<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/therapist">Therapist Management </a>
            </li>
            <li class="breadcrumb-item">Edit</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">

            <div class="main-block-innner mb40 mt40">
                <div class="add-store-block input-style">

                    <!-- **********************Subadmin profile image ****************  -->

                    <div class="text-center mt-4 mb-5">
                        <div class="flex-block align-center">
                            <div class="profile_block" style="position: relative">
                                <img [src]="imageUrl || 'assets/img/profile-img.jpg'" class="imagePicture"
                                    alt="Patient image" (error)="onImageError($event)" />
                                <br>
                                <span class="camera">
                                    <i class="fa fa-camera" style="display:flex; ">
                                        <input type="file" class="cameraInput" accept="image/jpg,image/jpeg,image/png"
                                            id="file" (change)="ValidateFileUpload($event)">
                                    </i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="addTherapistForm">
                        <div class="form-group row align-items-center d-flex mb-3">
                            <label class="col-md-2">
                                <h6> Type -</h6>
                            </label>
                            <div class="col-md-3 d-flex align-items-center">
                                <input type="radio" value="THERAPIST" name="Type" [(ngModel)]="selectedTherapy"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="ms-2">Therapist</label>
                            </div>
                            <div class="col-md-3 d-flex align-items-center">
                                <input type="radio" name="Type" value="MEDICAL" [(ngModel)]="selectedTherapy"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="ms-2">Medical</label>
                            </div>
                            <div class="col-md-4 d-flex align-items-center">
                                <input type="radio" name="Type" value="CASE_MANAGER" [(ngModel)]="selectedTherapy"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="ms-2">Case Manager</label>
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Select Program :</h6>
                            </label>
                            <div class="col-md-8">

                                <div class="multiselect">
                                    @for (opt of programList; track opt; let i = $index) {
                                    <label>
                                        <input type="checkbox" [checked]="opt?.checked == true" id="programId"
                                            (change)="programChange($event.target.checked,opt?._id)" name="option[]"
                                            [value]="opt?._id" />
                                        <span class="ms-1"> {{opt?.title}}</span>
                                    </label>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> First Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="First name"
                                    [formControl]="addTherapistForm.controls['firstName']" maxlength="256"
                                    (keypress)="service.allowOnlyAlphabets($event)" minlength="2">
                                @if((addTherapistForm.controls['firstName'].dirty ||
                                addTherapistForm.controls['firstName'].touched) &&
                                addTherapistForm.controls['firstName'].invalid){
                                <div class="error-block">
                                    @if(addTherapistForm.controls['firstName'].hasError('required')){
                                    <small style='color:red'
                                        [ngClass]="{error:addTherapistForm.controls['firstName'].hasError('required')}">
                                        *Please enter user first name.
                                    </small>
                                    }
                                    @if(addTherapistForm.controls['firstName'].hasError('pattern')){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['firstName'].hasError('pattern')}">
                                        *First name should be characters only.
                                    </small>
                                    }
                                    @if(addTherapistForm.controls['firstName'].hasError('maxlength') &&
                                    addTherapistForm.controls['firstName'].dirty){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['firstName'].hasError('maxlength') && addTherapistForm.controls['firstName'].dirty}">
                                        *First name should be maximum 256 characters.
                                    </small>
                                    }
                                    @if(addTherapistForm.controls['firstName'].hasError('minlength') &&
                                    !addTherapistForm.controls['firstName'].hasError('pattern')){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['firstName'].hasError('minlength') && addTherapistForm.controls['firstName'].dirty}">
                                        *First name should be atleast 2 characters.
                                    </small>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="Last name"
                                    [formControl]="addTherapistForm.controls['lastName']" maxlength="256"
                                    (keypress)="service.allowOnlyAlphabets($event)" minlength="2">
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Email :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="email" disabled class="form-control" placeholder="Email"
                                    (keypress)="passwordKeyPress($event)"
                                    [formControl]="addTherapistForm.controls['email']" maxlength="50">
                                @if(addTherapistForm.controls['email'].dirty &&
                                addTherapistForm.controls['email'].invalid){
                                <div class="error-block">
                                    @if(addTherapistForm.controls['email'].hasError('required')){
                                    <small style='color:red'
                                        [ngClass]="{error:addTherapistForm.controls['email'].hasError('required')}">*Please
                                        enter an
                                        email.</small>
                                    }
                                    @if(addTherapistForm.controls['email'].hasError('pattern')){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['email'].hasError('pattern')}">*Please
                                        enter
                                        valid email.</small>
                                    }
                                    @if(addTherapistForm.controls['email'].hasError('maxlength') &&
                                    !addTherapistForm.controls['email'].hasError('pattern')){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['email'].hasError('maxlength') && !addTherapistForm.controls['email'].hasError('pattern')}">*Please
                                        enter valid email.</small>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline mb-3">
                            <label class="col-md-4">
                                <h6>Phone Number : </h6>
                            </label>
                            <div class="col-md-3">
                                <select name="patient" disabled style="padding: 0 30px" formControlName="phoneCode"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    <option value="">Dial Code</option>
                                    @for (data of countryArr; track data; let i = $index) {
                                    <option [value]="data.phone_code">
                                        {{data.phone_code}} &nbsp; {{data.name}}</option>
                                    }
                                </select>

                            </div>
                            <div class="col-md-5">
                                <input type="tel" disabled class="form-control" placeholder="Phone Number"
                                    (keypress)="inputKeyPress($event)"
                                    [formControl]="addTherapistForm.controls['phoneNumber']" maxlength="20">
                                @if(addTherapistForm.controls['phoneNumber'].dirty &&
                                addTherapistForm.controls['phoneNumber'].invalid){
                                <span class="error-block">
                                    @if(addTherapistForm.controls['phoneNumber'].hasError('required')){
                                    <small style='color:red'
                                        [ngClass]="{error:addTherapistForm.controls['phoneNumber'].hasError('required')}">
                                        *Please enter a phone number.
                                    </small>
                                    }
                                    @if(addTherapistForm.controls['phoneNumber'].hasError('pattern')){
                                    <small style='color:red'
                                        [ngClass]="{error: addTherapistForm.controls['phoneNumber'].hasError('pattern')}">
                                        *Please enter valid phone number.
                                    </small>
                                    }
                                </span>
                                }
                            </div>

                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Address :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" formControlName="address" placeholder="Address"
                                    minlength="2">
                                @if(addTherapistForm.controls['address'].dirty &&
                                addTherapistForm.controls['address'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Address is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Time Zone :</h6>
                            </label>
                            <div class="col-md-8">
                                <select name="" class="custom-select" id="" formControlName="timeZone">
                                    <option value="-720">GMT-12:00</option>
                                    <option value="-660">GMT-11:00</option>
                                    <option value="-600">GMT-10:00</option>
                                    <option value="-570">GMT-09:30</option>
                                    <option value="-540">GMT-09:00</option>
                                    <option value="-480">GMT-08:00</option>
                                    <option value="-420">GMT-07:00</option>
                                    <option value="-360">GMT-06:00</option>
                                    <option value="-300">GMT-05:00</option>
                                    <option value="-240">GMT-04:00</option>
                                    <option value="-180">GMT-03:00</option>
                                    <option value="-120">GMT-02:00</option>
                                    <option value="-60">GMT-01:00</option>
                                    <option value="0">GMT</option>
                                    <option value="60">GMT+01:00</option>
                                    <option value="120">GMT+02:00</option>
                                    <option value="180">GMT+03:00</option>
                                    <option value="240">GMT+04:00</option>
                                    <option value="270">GMT+04:30</option>
                                    <option value="300">GMT+05:00</option>
                                    <option value="330">GMT+05:30</option>
                                    <option value="345">GMT+05:45</option>
                                    <option value="360">GMT+06:00</option>
                                    <option value="390">GMT+06:30</option>
                                    <option value="420">GMT+07:00</option>
                                    <option value="480">GMT+08:00</option>
                                    <option value="525">GMT+08:45</option>
                                    <option value="540">GMT+09:00</option>
                                    <option value="570">GMT+09:30</option>
                                    <option value="600">GMT+10:00</option>
                                    <option value="630">GMT+10:30</option>
                                    <option value="660">GMT+11:00</option>
                                    <option value="720">GMT+12:00</option>
                                    <option value="765">GMT+12:45</option>
                                    <option value="780">GMT+13:00</option>
                                    <option value="840">GMT+14:00</option>
                                </select>
                                @if(addTherapistForm.controls['timeZone'].dirty &&
                                addTherapistForm.controls['timeZone'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Time Zone is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Create Password :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="password" class="form-control" placeholder="Create Password"
                                    formControlName="password" maxlength="256" minlength="2">
                                @if(addTherapistForm.controls['password'].dirty &&
                                addTherapistForm.controls['password'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Create Password is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Confirm Password :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="password" class="form-control" placeholder="Confirm Password"
                                    maxlength="256" formControlName="conPassword" minlength="2">
                                @if(addTherapistForm.controls['conPassword'].dirty){
                                <span>
                                    @if(addTherapistForm.controls['conPassword'].value !=
                                    addTherapistForm.controls['password'].value){
                                    <span class="error-block">
                                        <small style='color:red'>*Password is mismatched. </small>
                                    </span>
                                    }
                                </span>
                                }

                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Speciality :</h6>
                            </label>
                            <div class="col-md-8">
                                <select name="" class="custom-select" id="" formControlName="speciality">
                                    <option value=""> Speciality </option>
                                    <option value="ENGLISH"> English </option>
                                    <option value="FRENCH"> French </option>
                                    <option value="SPANISH"> Spanish </option>

                                </select>
                                @if(addTherapistForm.controls['speciality'].dirty &&
                                addTherapistForm.controls['speciality'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Speciality is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Degree :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" formControlName="degree" placeholder="Degree"
                                    maxlength="256" minlength="2">
                                @if(addTherapistForm.controls['degree'].dirty &&
                                addTherapistForm.controls['degree'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Degree is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Institution :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" formControlName="institution"
                                    placeholder="Institution" maxlength="256" minlength="2">
                                @if(addTherapistForm.controls['institution'].dirty &&
                                addTherapistForm.controls['institution'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Institution is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="my-4 text-center">
                            <button class="btn btn-theme" [disabled]="addTherapistForm.invalid"
                                (click)="editTherapist()">Update Therapist</button>

                        </div>
                    </form>
                    <form [formGroup]="editScheduleForm">

                        <div class="form-group row my-2 mt-4 align-items-center">
                            <h5 class="col-md-12"> Schedules : </h5>

                        </div>

                        <div class="form-group row align-items-center">
                            <div class="col-md-6">
                                <label for=""> From: </label>
                                <input type="date" [min]="service.getPastBlock()" formControlName="startDate"
                                    placeholder="yyyy-mm-dd" name="" class="form-control" id="">
                            </div>
                            <div class="col-md-6">
                                <label for=""> To : </label>
                                <input type="date" [min]="service.getPastBlock()" formControlName="endDate"
                                    placeholder="yyyy-mm-dd" name="" class="form-control" id="">
                            </div>
                        </div>

                        <div class="form-group my-4  align-items-center d-flex">
                            <span class="round"
                                [ngClass]="{active:((Sunday.checked == true )&& (Sunday.week == 'Sunday'))}">S
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Sunday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>
                            <span class="round"
                                [ngClass]="{active:(Monday.checked == true) && (Monday.week  == 'Monday') }">M
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Monday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>

                            <span class="round "
                                [ngClass]="{active:(Tuesday.checked == true) && (Tuesday.week  == 'Tuesday') }">T
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Tuesday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>

                            <span class="round"
                                [ngClass]="{active:(Wednesday.checked == true)&& (Wednesday.week    == 'Wednesday')}">W
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Wednesday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>

                            <span class="round"
                                [ngClass]="{active:(Thursday.checked == true) && (Thursday.week == 'Thursday') }">T
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Thursday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>

                            <span class="round"
                                [ngClass]="{active:(Friday.checked  == true) && (Friday.week   == 'Friday') }">F
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Friday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>

                            <span class="round"
                                [ngClass]="{active:(Saturday.checked  == true) && (Saturday.week   == 'Saturday') }">S
                                <input type="checkbox" (change)="weekChange($event.target.checked,'Saturday')"
                                    class="myCheckbox cursor-pointer" name="" id="">
                            </span>


                        </div>

                        <div class="form-group row align-items-center" style="line-height: 2;">
                            <div class="col-md-4">
                                <label for="">
                                    <h6>Start Time:</h6>
                                </label>
                                <input type="time" formControlName="startHourTime" name="" class="form-control  " id="">
                            </div>
                            <div class="col-md-4">
                                <label for="">
                                    <h6>End Time: </h6>
                                </label>
                                <input type="time" formControlName="endHourTime" name="" class="form-control" id="">
                            </div>
                        </div>

                        <div class="form-group row my-4 align-items-center">
                            <label class="col-md-4">
                                <h6> Interval :</h6>
                            </label>
                            <div class="col-md-8">
                                <select name="" formControlName="interval" class="custom-select" id="">
                                    <option value="">Select Interval</option>
                                    <option value="15">15 Minutes</option>
                                    <option value="20">20 Minutes</option>
                                    <option value="30">30 Minutes</option>
                                    <option value="60">60 Minutes</option>
                                </select>
                                @if(editScheduleForm.controls['interval'].dirty &&
                                editScheduleForm.controls['interval'].hasError('required')){
                                <span class="error-block">
                                    <small style='color:red'>*Interval is required. </small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="text-center my-4">
                            <button class="btn btn-theme" [disabled]="editScheduleForm.invalid"
                                (click)="setSlotApi()">Update Schedule</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/therapist">Cancel</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</main>